module.exports = __webpack_public_path__ + "img/arrow-right-to-bracket-solid.681be700.svg";